export default __webpack_public_path__ + "static/media/arrow3.9a40bde4.png";